import './LiveDot.css';

export type LiveDotVariant = 'live' | 'blink' | 'waiting' | 'replay' | 'warn';

export interface LiveDotProps {
  variant: LiveDotVariant;
  /** Só em `live`: chave nova → o ping (A10) recomeça. */
  pulseKey?: string | number;
}

/**
 * Ponto de estado (§3.8 `LiveDot`), sempre decorativo: o estado está no texto ao lado. O miolo respira (A11) ou pisca
 * (A12); o ping (A10) é um irmão com `key`, remontado a cada `pulseKey`. As animações só existem sob
 * `prefers-reduced-motion: no-preference` (LiveDot.css); com movimento reduzido o ponto fica parado, opacidade 1.
 */
export function LiveDot({ variant, pulseKey }: LiveDotProps) {
  return (
    <span class={`live-dot live-dot--${variant}`} data-testid="live-dot" data-state={variant} aria-hidden="true">
      <span class="live-dot__core" />
      {variant === 'live' && <span key={pulseKey ?? 0} class="live-dot__ping" />}
    </span>
  );
}
